import { Link, useLocation } from 'react-router-dom';
import { Seo } from '../../components/Seo';

export function NotFoundPage() {
  const location = useLocation();
  return (
    <>
      <Seo name="notFound" />
      <div className="mx-auto flex max-w-2xl flex-col items-center px-4 py-24 text-center">
        <p className="rounded border border-border px-4 py-1 font-mono text-sm text-muted">404</p>
        <h1 className="mt-6 font-display text-3xl font-semibold">Oops! Page not found</h1>
        <p className="mt-3 text-muted">
          We couldn’t find anything at <code className="rounded bg-background px-1.5 py-0.5 text-xs">{location.pathname}</code>.
          The link may be broken, or the article may have been unpublished or renamed.
        </p>
        <div className="mt-8 flex gap-3">
          <Link to="/" className="rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground">Return to home</Link>
          <Link to="/latest" className="rounded-md border border-border px-4 py-2 text-sm">Read the latest</Link>
        </div>
      </div>
    </>
  );
}
